export default __webpack_public_path__ + "static/media/gallery7.b0d5d66b.jpg";